import React, {
  Children,
  cloneElement,
  isValidElement,
  ReactNode,
} from "react";
import { Redirect, Route } from "react-router-dom";
import { checkAuthStatus } from "../../utils/react";
import { RootState } from "../../reducers";
import { connect } from "react-redux";

interface Props {
  path: string;
  sessionId: string;
  children: ReactNode;
  exact?: boolean;
}

const AuthRoute: React.FC<Props> = ({ path, sessionId, children, exact }) => {
  return (
    <Route
      path={path}
      exact={exact}
      render={(props) => {
        if (checkAuthStatus(sessionId)) {
          const childrenWithProps = Children.map(children, (child) => {
            // Checking isValidElement is the safe way and avoids a TS error too.
            if (isValidElement(child)) {
              return cloneElement(child, { ...props });
            }

            return child;
          });

          return <div>{childrenWithProps}</div>;
        } else {
          const location = props.location.pathname.split("/");

          return (
            <Redirect
              to={
                location.length > 3
                  ? `/${location[1]}/${location[2]}/login`
                  : "/"
              }
            />
          );
        }
      }}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  sessionId: state.app.sessionId,
});

const connector = connect(mapStateToProps);

export default connector(AuthRoute);
